// extracted by mini-css-extract-plugin
module.exports = {"item":"DashboardNavItem_item__ZsNyy","icon":"DashboardNavItem_icon__1ZIYu"};